<template>
  <div id="club-swimming" class="club-swimming flex flex-col app-page-wrapper absolute">
    <menu-component menu-type="club-swimming" :title="$t('club.swimming')">
      <app-icon
        v-tippy="{
          theme: 'WSM',
          content: $t('club.clubEmployeeDesc'),
          placement: 'left',
          maxWidth: '62rem',
        }"
        icon-name="info-70"
        class="modal-title-icon"
      />
    </menu-component>
    <section class="w-full h-full safe-area">
      <clubs-building-employees building-type="swimming" />
    </section>
  </div>
</template>

<script lang="ts">
import ClubsBuildingEmployees from '@/components/Club/ClubsBuildingEmployees.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ClubsSwimming',
  components: {
    ClubsBuildingEmployees,
  },
})
</script>
